import { render } from "./AdImageBox.vue?vue&type=template&id=63346252&scoped=true"
import script from "./AdImageBox.vue?vue&type=script&lang=js"
export * from "./AdImageBox.vue?vue&type=script&lang=js"

import "./AdImageBox.vue?vue&type=style&index=0&id=63346252&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63346252"

export default script